<template>
    <small 
        class="form-error" 
        v-if="error"
    >{{ error }}</small>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        name: {
            type: String,
            required: true,
        },
        index:{
            type: Number,
            default: null,
        },
    },

    computed: {
        error: function() {
            if (!this.errors[this.name]) {
                return null;
            }
            if (this.index) {
                return this.errors[this.name][this.index][0] || null;
            }

            return this.errors[this.name][0];
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ErrorComponent.vue